module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-17-df27c4c17e746187b85dfe85012979a3.jpg";